module.exports = __webpack_public_path__ + "static/img/Concert-of-NewMusic-LivingTheaterFlierPoster_BrechtNotebook4pp200-230_1960_FPO.4e07674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/Concert-of-NewMusic-LivingTheaterFlierPoster_BrechtNotebook4pp200-230_1960_FPO.jpg
// module id = L68Z
// module chunks = 0